export default {
  install(Vue, options) {
    Vue.prototype.$msgError = function (msg,callback) {
      if(sessionStorage.getItem('isbounced')=='false'){
        // this.$store.commit('changeBounced', true);
        sessionStorage.setItem('isbounced',true);
        this.$alert(msg, '', {
          confirmButtonText: '确定',
          type: '',callback:action=>{
            if (callback) {
              callback();
            }else{
              sessionStorage.setItem('isbounced',false);
            }
          }
        });
      }
    };
    Vue.prototype.$msgInfo = function (msg,callback) {
      this.$alert(msg, '', {
        confirmButtonText: '确定',
        closeOnClickModal: true,
        type: '',callback:action=>{
          if (callback) {
            callback();
          }
        }
      });
    };

    Vue.prototype.$msgWarning = function (msg, callback) {
      this.$alert(msg, '', {
        confirmButtonText: '确定',
        type: ''
        , callback: action => {
          if (callback) {
            callback();
          }
        }
      });
    };
    Vue.prototype.$msgConfirm = function (msg, yesFn, cancelFn) {
      this.$confirm(msg, '操作确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (yesFn) {
          yesFn()
        }
      }).catch(() => {
        if (cancelFn) {
          cancelFn()
        }
      });
    }
    // Vue.prototype.$myset=function(name,value){
    //   let obj1={};
    //   obj1.name=name;
    //   obj1.value=value;
    //   this.$store.commit("myset",obj1);
    // }
    // Vue.prototype.$myget=function(name){
    //   let myvalue='';
    //   switch(name){
    //     case 'optimizeType':myvalue=this.$store.state.optimizeType1;break;
    //     case 'optimizeName':myvalue=this.$store.state.optimizeName1;break;
    //     case 'resourceType':myvalue=this.$store.state.resourceType1;break;
    //     case 'resourceId':myvalue=this.$store.state.resourceId1;break;
    //   }
    //   return myvalue;
    // }
  }
}



// WEBPACK FOOTER //
// ./src/utils/messagebox.js